import { localizeWithPath } from '../../../../../../nls.js';
import { MenuId } from '../../../../../../platform/actions/common/actions.js';
import { RawContextKey } from '../../../../../../platform/contextkey/common/contextkey.js';
const _moduleId = "vs/workbench/contrib/notebook/browser/controller/chat/notebookChatContext";
const CTX_NOTEBOOK_CELL_CHAT_FOCUSED = ( (new RawContextKey('notebookCellChatFocused', false, ( localizeWithPath(_moduleId, 0, "Whether the cell chat editor is focused")))));
const CTX_NOTEBOOK_CHAT_HAS_ACTIVE_REQUEST = ( (new RawContextKey('notebookChatHasActiveRequest', false, ( localizeWithPath(_moduleId, 1, "Whether the cell chat editor has an active request")))));
const CTX_NOTEBOOK_CHAT_USER_DID_EDIT = ( (new RawContextKey('notebookChatUserDidEdit', false, ( localizeWithPath(
 _moduleId,
 2,
 "Whether the user did changes ontop of the notebook cell chat"
)))));
const CTX_NOTEBOOK_CHAT_OUTER_FOCUS_POSITION = ( (new RawContextKey('notebookChatOuterFocusPosition', '', ( localizeWithPath(
 _moduleId,
 3,
 "Whether the focus of the notebook editor is above or below the cell chat"
)))));
const MENU_CELL_CHAT_INPUT = MenuId.for('cellChatInput');
const MENU_CELL_CHAT_WIDGET = MenuId.for('cellChatWidget');
const MENU_CELL_CHAT_WIDGET_STATUS = MenuId.for('cellChatWidget.status');
const MENU_CELL_CHAT_WIDGET_FEEDBACK = MenuId.for('cellChatWidget.feedback');
MenuId.for('cellChatWidget.toolbar');
export { CTX_NOTEBOOK_CELL_CHAT_FOCUSED, CTX_NOTEBOOK_CHAT_HAS_ACTIVE_REQUEST, CTX_NOTEBOOK_CHAT_OUTER_FOCUS_POSITION, CTX_NOTEBOOK_CHAT_USER_DID_EDIT, MENU_CELL_CHAT_INPUT, MENU_CELL_CHAT_WIDGET, MENU_CELL_CHAT_WIDGET_FEEDBACK, MENU_CELL_CHAT_WIDGET_STATUS };
